import React from 'react';
import { Card, Row, Col } from 'antd';
import AnyChart from 'anychart-react';
import ExposureTable from './ExposureTable';
import NivoBarChart from '../../../charts/nivo/NivoBarChart';
import NivoScatterChart from "../../../charts/nivo/NivoScatterChart";
import { mapExposureColor, findMaximumExposures } from './utils';
import { chartBaseJsonConfig, scatterConfigJson } from '../../../charts/Anychart/applyAnychartStyles';

const ExposureBubbleChart = ({ maxExposureData, currentWeights }) => {
  const scatterData = maxExposureData.map((item) => ({
    x: currentWeights[item.x.toLowerCase()] * 100, // assuming currentWeights are fractions
    value: parseFloat(item.value),
    name: item.x,
    fill: mapExposureColor(item.value),
    stroke: mapExposureColor(item.value),
    markerSize: 15,
  }));

  let scatterChartSettings = {
    type: 'scatter',
    data: scatterData,
    yAxis: {
      title: 'Max Exposure (%)',
    },
    xAxis: {
      title: 'Current Exposure (%)',
    },
    height: '600px',
    ...scatterConfigJson.apply(),
  };
  scatterChartSettings = chartBaseJsonConfig.applyBaseConfig(scatterChartSettings);
  return <AnyChart id={'scatter-chart-exposure-chart'} {...scatterChartSettings} />;
};

const ExposureBarChart = ({ maxExposureData }) => {
  let colors = {};
  const barChartData = maxExposureData.map((item) => {
    colors[item.x] = mapExposureColor(item.value);
    return { id: item.x, [item.x]: parseFloat(item.value) };
  });
  const keys = maxExposureData.map((item) => item.x);

  return (
    <div style={{ height: 300, width: '100%' }}>
      <NivoBarChart
        data={barChartData}
        keys={keys}
        customColors={colors}
        vertical={true}
        barPadding={0.3}
        rotateLabels={90}
        mode={'stacked'}
        legendSize={'small'}
        borderRadius={4}
        showLegend={false}
      />
    </div>
  );
};

const MaxExposure = ({ treeData, symbols }) => {
  const maxExposureData = findMaximumExposures(treeData);
  const currentWeights = symbols;

  console.log(maxExposureData, currentWeights);
  const nivoScatterData = maxExposureData.map((d) => {
    return {
      id: d.x,
      data: [{ x: currentWeights[d.x.toLowerCase()] * 100, y: d.value }],
    }
  });

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={10} lg={8}>
        <Card bordered={false}>
          <ExposureTable maxExposureData={maxExposureData} currentWeights={currentWeights} />
        </Card>
      </Col>
      <Col xs={24} sm={24} md={14} lg={16}>
        <Card bordered={false} style={{ marginBottom: '16px' }}>
          <ExposureBarChart maxExposureData={maxExposureData} />
          <div style={{ height: '300px', width: '100%' }}>
            <NivoScatterChart data={nivoScatterData} keys={nivoScatterData.map(x=>x.id)} />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default MaxExposure;